<template>
  <div class="mobile submission-details">
    <div class="message_date">{{detailsValue.dsCreateTime}}</div>
    <DsfMessagePanel arrowDirection="right">
      <div slot="content" class="message_title">
        <p class="title">{{detailsValue.typeText || ''}}</p>
        <div class="content">{{detailsValue.suggest || ''}}</div>
        <div class="message_img">
          <van-image v-for="(item,index) of imgUrl()" :key="index" radius="5" width="80" height="80" fit="cover" :src="item.relativePath" @click="messageChange(index)">
            <template v-slot:error>
              <img :src="require('../../assets/styles/themes/img/submissionErr_mobile.png')" alt="" class="err_img">
            </template>
          </van-image>
        </div>
      </div>
    </DsfMessagePanel>
    <template v-if="detailsValue.replyStatusValue=='1'">
      <div v-for="(item,index) of detailsValue.suggestReplyList" :key="index">
        <div class="message_date">{{item.dsCreateTime || ''}}</div>
        <DsfMessagePanel arrowDirection="left" v-if="detailsValue.replyStatusValue=='1'">
          <div slot="content" class="message_title">
            <div class="reply">
              <span>回复内容：</span>
              {{item.detail}}（{{item.dsCreateUserName}}）
            </div>
          </div>
        </DsfMessagePanel>
      </div>
    </template>
    <van-image-preview v-model="showImage" :images="preview" class-name="preview_box" :start-position="startPosition">
    </van-image-preview>
  </div>
</template> 

<script>
import DsfMessagePanel from "./messagePanel.vue";
export default dsf.component({
  name: "DsfMobileSubmissionDetails",
  ctrlCaption: "历史提交详情",
  mixins: [$mixins.control],
  components: {
    DsfMessagePanel,
  },
  data() {
    return {
      detailsValue: {},
      isHeadmaster: false,
      showImage: false,
      preview: [],
      startPosition: 0,
    };
  },
  methods: {
    // 图片预览+
    messageChange(index) {
      this.startPosition = index;
      this.showImage = true;
    },
    imgUrl() {
      if (this.detailsValue.attachment) {
        let imgArr = JSON.parse(this.detailsValue.attachment);
        return imgArr
      } else {
        return []
      }
    },
    getMessageData() {
      let data = {
        id: this.queryString.id || '',
      }
      let that = this;
      this.$http.get('/mobile/classes/suggest/getSuggestDetail', data).done((res) => {
        if (res.success && res.state == 20000 && res.data) {
          that.detailsValue = res.data;
          if (this.detailsValue.attachment) {
            let imgArr = JSON.parse(this.detailsValue.attachment);
            this.preview = [];
            imgArr.forEach(element => {
              this.preview.push(element.relativePath)
            });
          }
        } else {
          dsf.layer.message(res.message, false);
        }
      })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
    },
    // 调用已读未读
    setToRead() {
      let data = {
        id: this.queryString.id || '',
      }
      this.$http.post('/mobile/classes/suggest/setToRead', data).done((res) => {
        if (res.success && res.state == 20000 && res.data) {
          // dsf.layer.message(res.message)
        } else {
          dsf.layer.message(res.message, false);
        }
      })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
    },
  },

  created() {
    if (this.isDesign) {
      this.detailsValue = {
        attachment: "[{\"originalFileName\":\"33.jpg\",\"name\":\"33\",\"suffix\":\"jpg\",\"size\":48483,\"contentType\":\"image/jpeg\",\"relativePath\":\"/upload/files/20220304/5490bd5eefd34af3987ae42c8b5b59dc.jpg\",\"absolutePath\":\"http://localhost:8080/upload/files/20220304/5490bd5eefd34af3987ae42c8b5b59dc.jpg\",\"uploadDate\":\"2022-03-04 14:38:04\",\"id\":\"a76aa062a3a04ffe82953aa74dda97b6\",\"url\":\"/upload/files/20220304/5490bd5eefd34af3987ae42c8b5b59dc.jpg\"},{\"originalFileName\":\"44.jpg\",\"name\":\"44\",\"suffix\":\"jpg\",\"size\":12462,\"contentType\":\"image/jpeg\",\"relativePath\":\"/upload/files/20220304/55ef5cdac0144bdab8bf72e0d904aae8.jpg\",\"absolutePath\":\"http://localhost:8080/upload/files/20220304/55ef5cdac0144bdab8bf72e0d904aae8.jpg\",\"uploadDate\":\"2022-03-04 14:38:04\",\"id\":\"dd1f84ec8e074b6b97ba17055c919878\",\"url\":\"/upload/files/20220304/55ef5cdac0144bdab8bf72e0d904aae8.jpg\"},{\"originalFileName\":\"555.jpg\",\"name\":\"555\",\"suffix\":\"jpg\",\"size\":15210,\"contentType\":\"image/jpeg\",\"relativePath\":\"/upload/files/20220304/01729e5ad16142f1bbd66a4ab41f3070.jpg\",\"absolutePath\":\"http://localhost:8080/upload/files/20220304/01729e5ad16142f1bbd66a4ab41f3070.jpg\",\"uploadDate\":\"2022-03-04 14:38:04\",\"id\":\"12eda20ee248406eb1f37d7529b518ba\",\"url\":\"/upload/files/20220304/01729e5ad16142f1bbd66a4ab41f3070.jpg\"}]",
        classId: "f7c8a9d37e1e4086873f216cf548e7da",
        className: "测试请假与评估关联班",
        dsCreateTime: "2022-03-04 14:38",
        dsCreateUserId: "b4e96b5f66b642f9b6c6dc695f68f481",
        dsCreateUserName: "学员01",
        id: "6aece158777244b79946e71224098e48",
        photo: "[{\"originalFileName\":\"f18d063759cdf9b7dff6477fffce279b.jpg\",\"suffix\":\"jpg\",\"size\":19422,\"uploadDate\":\"2022-03-02 10:09:40\",\"relativePath\":\"/upload/files/20220302/054b2d2adba141df9f38863e05ec98e4.jpg\",\"name\":\"f18d063759cdf9b7dff6477fffce279b\",\"absolutePath\":\"http://192.168.0.61/upload/files/20220302/054b2d2adba141df9f38863e05ec98e4.jpg\",\"id\":\"123aa8721985468282c7885d020fe33a\",\"contentType\":\"image/jpeg\"}]",
        replyStatusText: "未回复",
        replyStatusValue: "0",
        stuId: "e03c56cbff9641a3bea27e37b42845b0",
        stuName: "学员01",
        suggest: "打算大蘇打給門打開了哥們囧放大鏡看你哦過段時間你哦",
        suggestReplyList: [],
        typeText: "后勤保障",
        typeValue: "3"
      }
    } else {
      this.getMessageData();
      this.setToRead()
    }
  }
})
</script>

<style>
</style>